export const queryKeys = {
  session: ['session'],
  config: ['config'],
  sites: userId => ['sites', userId],
  analytics: (userId, siteUrl, name, body) => ['analytics', userId, siteUrl, name, body],
  allAnalytics: ['analytics'],
  keywordVolume: (userId, country, keywords) => ['keyword-volume', userId, country, keywords],
  adminUsers: ['admin-users'],
  checkoutConfirmation: sessionId => ['checkout-confirmation', sessionId],
};
